import { defineComponent } from "vue";
const _sfc_main = defineComponent({
  name: "DragHorizontal"
});
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "currentColor",
  viewBox: "0 0 24 24"
};
const _hoisted_2 = /* @__PURE__ */ _createElementVNode("path", {
  "fill-rule": "evenodd",
  d: "M9 3V11.25H4.3725L6.3075 9.3075L5.25 8.25L1.5 12L5.25 15.75L6.3075 14.6925L4.3725 12.75H9V21H10.5V3H9ZM18.75 8.25L17.6925 9.3075L19.6275 11.25H15V3H13.5V21H15V12.75H19.6275L17.6925 14.6925L18.75 15.75L22.5 12L18.75 8.25Z",
  "clip-rule": "evenodd"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("svg", _hoisted_1, _hoisted_3);
}
import _export_sfc from "/plugin-vue/export-helper";
export default /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render], ["__file", "/Users/yimingtian/projects/ym/yimian-ui/packages/icons/src/DragHorizontal.vue"]]);
